export const postData = (e) => {
    return {
      ...e,
      specialty_title: e?.specialty_id?.label,
      specialty_id: e?.specialty_id?.id,
      suffix: e?.suffix?.label,
      state: e?.state?.id,
      frequency: e.share_record && e?.frequency?.label,
      method: e.method && e?.method?.label,
      title: e?.title?.label,
    };
  };
  
  export const getFormData = (data) => {
    return {
      ...data,
      specialty_id: data?.specialty_title && {
        id: data?.specialty_id,
        label: data?.specialty_title,
      },
      phone: data?.phone && convertNumberInToMask(data?.phone),
      phonew1: data?.phonew1 && convertNumberInToMask(data?.phonew1),
      phonecell: data?.phonecell && convertNumberInToMask(data?.phonecell),
      fax: data?.fax && convertNumberInToMask(data?.fax),
      suffix: data?.suffix && { label: data?.suffix },
      state: data?.state && { label: data?.state },
      frequency: data?.frequency && { label: data?.frequency },
      method: data?.method && { label: data?.method },
      title: data?.title && { label: data?.title },
      share_record: data?.frequency && data?.method && true
  
  
    };
  };
  export const defaultValue = () => {
    return {
      title: "",
      fname: "",
      mname: "",
      lname: "",
      suffix: "",
      street: "",
      streetb: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      phonew1: "",
      phonecell: "",
      fax: "",
      email: "",
      npi: "",
      specialty_id: "",
      share_record: "",
      frequency: "",
      method: ""
    }
  }
  
  export const convertNumberInToMask = (num) => {
    var USNumber = num?.match(/(\d{3})(\d{3})(\d{4})/);
    if (USNumber) {
      USNumber = "(" + USNumber[1] + ") " + USNumber[2] + "-" + USNumber[3]
      return (USNumber)
  
    }
    else{
      return ""
    }
  }